import requestStatuses, { RequestStatus } from '@cinch/oxd-utils/request-status/src'
import { get as storageGet, StorageKeys } from '@cinch/oxd-utils/storage/src'

import * as types from '../types'

export interface ProfileReducer {
  fetchStatus: string
  updateStatus: string
  data: Cinch.UserProfileResponse
  downloadStatus: RequestStatus
  downloadError: string
  downloadBlob: null | Blob
  deleteStatus: string
  deleteError: string
  changedPasswordStatus: string
  changedPasswordError: string
  signupFavouriteVehicleId?: number
  signupDirectFavouriteVehicleId?: string
}

export const initialState: ProfileReducer = {
  fetchStatus: requestStatuses.INITIAL,
  updateStatus: requestStatuses.INITIAL,
  changedPasswordStatus: requestStatuses.INITIAL,
  changedPasswordError: '',
  deleteStatus: requestStatuses.INITIAL,
  deleteError: '',
  downloadStatus: requestStatuses.INITIAL,
  downloadError: '',
  downloadBlob: null,
  data: {
    userId: '',
    email: '',
    picture: '',
    phoneNumber: '',
    firstName: '',
    lastName: '',
    location: '',
    town: '',
    postcode: '',
    latitude: null as number | null,
    longitude: null as number | null,
    distance: 0,
    preferenceSms: false,
    preferenceEmail: false,
    preferenceDigital: false,
    budget: 0,
    partExchange: false,
    finance: false,
    savedSearch: null,
    deliveryOption: 'DealershipOnly',
    ...storageGet(StorageKeys.profile),
  },
  signupFavouriteVehicleId: 0,
  signupDirectFavouriteVehicleId: '',
}

export default (state = initialState, { type, payload }: any): ProfileReducer => {
  switch (type) {
    case types.GET_PROFILE_REQUEST:
      return {
        ...state,
        data: {
          ...state.data,
        },
        fetchStatus: requestStatuses.PENDING,
      }
    case types.GET_PROFILE_SUCCESS: {
      return {
        ...state,
        fetchStatus: requestStatuses.SUCCESS,
        data: payload,
      }
    }
    case types.GET_PROFILE_FAILURE:
      return {
        ...state,
        fetchStatus: requestStatuses.ERROR,
      }
    case types.UPDATE_PROFILE_REQUEST:
      return {
        ...state,
        updateStatus: requestStatuses.PENDING,
      }
    case types.UPDATE_ANON_USER_PROFILE:
    case types.UPDATE_PROFILE_SUCCESS:
      return {
        ...state,
        updateStatus: requestStatuses.SUCCESS,
        data: {
          ...state.data,
          ...payload,
        },
      }
    case types.UPDATE_PROFILE_FAILURE:
      return {
        ...state,
        updateStatus: requestStatuses.ERROR,
      }
    case types.DOWNLOAD_ACCOUNT_DATA_REQUEST:
      return {
        ...state,
        downloadStatus: requestStatuses.PENDING,
        downloadError: '',
        downloadBlob: null,
      }
    case types.DOWNLOAD_ACCOUNT_DATA_FAILURE:
      return {
        ...state,
        downloadStatus: requestStatuses.INITIAL,
        downloadError: payload.message,
        downloadBlob: null,
      }
    case types.DOWNLOAD_ACCOUNT_DATA_RESET:
      return {
        ...state,
        downloadStatus: requestStatuses.INITIAL,
        downloadError: '',
        downloadBlob: null,
      }
    case types.DOWNLOAD_ACCOUNT_DATA_SUCCESS:
      return {
        ...state,
        downloadStatus: requestStatuses.INITIAL,
        downloadError: '',
        downloadBlob: payload,
      }
    case types.DELETE_ACCOUNT_REQUEST:
      return {
        ...state,
        deleteError: '',
        deleteStatus: requestStatuses.PENDING,
      }
    case types.DELETE_ACCOUNT_SUCCESS:
      return {
        ...state,
        deleteStatus: requestStatuses.SUCCESS,
      }
    case types.DELETE_ACCOUNT_FAILURE:
      return {
        ...state,
        deleteStatus: requestStatuses.INITIAL,
        deleteError: (payload && payload.response && payload.response.detail) || 'An error has occured',
      }
    case types.DELETE_ACCOUNT_REMOVE_ERROR:
      return {
        ...state,
        deleteError: '',
      }
    case types.CHANGE_PASSWORD_REQUEST:
      return {
        ...state,
        changedPasswordStatus: requestStatuses.PENDING,
        changedPasswordError: '',
      }
    case types.CHANGE_PASSWORD_REMOVE_ERROR:
      return {
        ...state,
        changedPasswordError: '',
      }
    case types.CHANGE_PASSWORD_FAILURE:
      return {
        ...state,
        changedPasswordStatus: requestStatuses.INITIAL,
        changedPasswordError: payload.response.detail,
      }
    case types.CHANGE_PASSWORD_SUCCESS:
      return {
        ...state,
        changedPasswordStatus: requestStatuses.SUCCESS,
        changedPasswordError: '',
      }
    case types.ADD_SIGNUP_FAVOURITE_VEHICLE:
      return {
        ...state,
        signupFavouriteVehicleId: payload,
      }
    case types.ADD_SIGNUP_DIRECT_FAVOURITE_VEHICLE:
      return {
        ...state,
        signupDirectFavouriteVehicleId: payload,
      }
    case types.SAVE_SEARCH:
      return {
        ...state,
        data: {
          ...state.data,
          savedSearch: payload.search,
        },
      }
    default:
      return { ...state }
  }
}
